<template>
  <div class="navbar-wrapper">
    <vs-input v-model="searchQuery" placeholder="Search" v-on:keyup.enter="handleSearch()">
      <template #icon>
        <box-icon name="search-alt-2" color="#868686"></box-icon>
      </template>
    </vs-input>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

library.add(faSearch);
export default {
  name: "Navbar",
  data() {
    return {
      searchQuery: ""
    };
  },
  methods: {
    handleSearch() {
      this.$router.push(`/s/photos/${this.searchQuery}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.navbar-wrapper {
  min-height: 80px;
  width: 100%;
  background: white;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon {
  color: gray;
}
</style>
